import React from "react";
import { Button, Modal } from "reactstrap";
import { ToastContainer } from "react-toastify";
import TableWrapper from "@/utils/TableWrapper";
import type { TableWrapperProps } from "@/utils/TableWrapper";

export type DisplayTemplatesViewProps = {
  templates: unknown[] | null | undefined;
  columns: TableWrapperProps<unknown>["columns"];
  message: React.ReactNode;
  alert: React.ReactNode;
  notificationModal: boolean;
  toggleModal: () => void;
};

/**
 * SCRUM-1128: the list renders through TableWrapper (search, sort, pagination),
 * so this view no longer carries a pager, a search box or sortable headers of
 * its own. `message` is still rendered in place of the table while the list is
 * empty — TableWrapper's fixed "No data available" cannot distinguish "loading"
 * from "none yet", and stacking both empty states would be worse than either.
 */
const DisplayTemplatesView = ({
  templates,
  columns,
  message,
  alert,
  notificationModal,
  toggleModal,
}: DisplayTemplatesViewProps) => {
  return (
    <>
      <div className="rna-wrapper">
        <ToastContainer />
      </div>

      {alert}

      {templates && templates.length > 0 ? (
        <TableWrapper data={templates} columns={columns} />
      ) : (
        <p className="text-center my-4">{message}</p>
      )}

      <Modal
        className="modal-dialog-centered modal-danger"
        contentClassName="bg-gradient-danger"
        isOpen={notificationModal}
        toggle={toggleModal}
      >
        <div className="modal-header">
          <h6 className="modal-title" id="modal-title-notification">
            Your attention is required
          </h6>
          <button
            aria-label="Close"
            className="close"
            data-dismiss="modal"
            type="button"
            onClick={toggleModal}
          >
            <span aria-hidden={true}>×</span>
          </button>
        </div>
        <div className="modal-body">
          <div className="py-3 text-center">
            <i className="fas fa-bell ni-3x" />
            <h4 className="heading mt-4">You should read this!</h4>
            <p>
              A small river named Duden flows by their place and supplies it with the
              necessary regelialia.
            </p>
          </div>
        </div>
        <div className="modal-footer">
          <Button className="btn-white" color="default" type="button">
            Ok, Got it
          </Button>
          <Button className="text-white ml-auto" color="link" type="button" onClick={toggleModal}>
            Close
          </Button>
        </div>
      </Modal>
    </>
  );
};

export default DisplayTemplatesView;
